import { HTMLAttributes } from 'react';
import { FontSize, FontWeight } from 'commons';
import { HeadingStyle } from './styles';

interface Props extends HTMLAttributes<HTMLElement> {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5';
  size?: FontSize;
  weight?: FontWeight;
}

/**
 *
 * @param as set the html tag of the heading, default is 'h2'
 * @param size set the size of the heading
 * @param weight set the font weight
 * @description more specific styles can be done by customizing the HeadingStyle styledComponent in a parent styledComponent
 */
export function Heading({
  as = 'h2',
  size = FontSize.font18,
  weight = FontWeight.regular,
  children,
  ...rest
}: Props) {
  return (
    <HeadingStyle as={as} $size={size} $weight={weight} {...rest}>
      {children}
    </HeadingStyle>
  );
}

export { HeadingStyle };
